import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const defaultRedirect = (role) => {
  if (role === 'hr') return '/employees';
  if (role === 'finance') return '/reports/cost';
  return '/dashboard';
};

const RoleRoute = ({ roles, children }) => {
  const { role } = useAuth();

  if (roles && !roles.includes(role)) {
    return <Navigate to={defaultRedirect(role)} replace />;
  }

  return children;
};

export default RoleRoute;
